import type { ApiDisplayLogic } from '../../../../internalTypes';
import type { DisplayLogic } from '../../../../types/survey';
import { mapLogicFilterGroup } from './mapLogicFilters';

export function mapDisplayLogic(raw: ApiDisplayLogic | undefined): DisplayLogic | undefined {
  if (!raw) return undefined;

  const condition = mapLogicFilterGroup(raw.condition);
  if (!condition) return undefined;

  return {
    condition,
    isDynamicAppearanceEnabled: raw.isDynamicAppearanceEnabled === true,
  };
}
